import { AfterViewInit, Component, createNgModuleRef, Injector, NgModuleRef, ViewChild, ViewContainerRef } from '@angular/core';
import { AbstractFilterComponent } from './base.filter.component';
import { GetFilterComponent } from '../filter-panel';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html'
})
export class FilterComponent implements AfterViewInit {

  @ViewChild('filter', { read: ViewContainerRef })
  filterTemplate!: ViewContainerRef;

  constructor(
    private mainModule: NgModuleRef<any>,
    private injector: Injector
  ) {
  }

  async ngAfterViewInit(): Promise<void> {
    this.filterTemplate.clear();

    GetFilterComponent().then(m => {
      if (m) {
        this.filterTemplate.createComponent<AbstractFilterComponent>(m.component, {
          ngModuleRef: m.module ? createNgModuleRef(m.module, this.injector) : this.mainModule
        });
      } else {
        this.filterTemplate.clear();
      }
    });
  }
}
